// src/lib/supabase/client.js
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL || "";
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

if (!url || !anon) {
  console.warn("[supabase] missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY");
}

let _supabase;

export function getSupabase() {
  if (!_supabase) {
    try {
      _supabase = createClient(url, anon, {
        auth: {
          flowType: "pkce",           // PKCE flow for better security (required for mobile OAuth)
          persistSession: true,
          storageKey: "fp-auth",
          detectSessionInUrl: true,   // Auto-detect OAuth callback codes in URL
          autoRefreshToken: true,
        },
      });
    } catch (e) {
      console.warn("[supabase] createClient failed:", e);
      // leave _supabase undefined so callers can check hasAuthAPI
    }
  }
  return _supabase;
}

if (!globalThis.__SUPABASE_SINGLETON_CREATED__) globalThis.__SUPABASE_SINGLETON_CREATED__ = 0;
globalThis.__SUPABASE_SINGLETON_CREATED__ += 1;
if (typeof window !== "undefined") {
  window.__SUPABASE_CLIENT_COUNT__ = (window.__SUPABASE_CLIENT_COUNT__ || 0) + 1;
  // eslint-disable-next-line no-console -- Supabase client initialization diagnostic
  console.debug("[Supabase] client instances created:", window.__SUPABASE_CLIENT_COUNT__);
}

const supabase = getSupabase();
export default supabase;
